// extracted by mini-css-extract-plugin
module.exports = {"label":"TextArea_label__DjkVN","wrap":"TextArea_wrap__3eMzU","textarea":"TextArea_textarea__2TRVg"};